module.exports = __webpack_public_path__ + "img/tracking-link-information-example.06de2ec7.jpg";